import React from 'react';
export function StickyHeader() {
  return <div className="sticky top-0 z-40 flex min-h-[36px] w-full items-center justify-center bg-primary px-4 py-2 text-center" data-id="element-205" data-mp="2zb2qzvd4yfy0">
      <p className="text-[11px] font-medium leading-snug text-surface sm:text-xs" data-id="element-206" data-mp="14tszax2ysfu8">
        Acceso inmediato · Pago único en USD · Pagás en tu moneda · Garantía de 7 días
      </p>
    </div>;
}